export const SELECT_DOCTOR = "SELECT_DOCTOR";
